export const facetDefaults = {
  values: [],
  selected: '',
  fetchSucceeded: true
};

export const productDefaults = {
  values: {},
  selected: [],
  hasSelectedProducts: false,
  fetchSucceeded: true
};

export const shopDefaults = {
  data: {}
};

export const pricingRequestDefaults = {
  sendingSucceeded: false
};

export const errorsDefaults = {
  error: '',
  hasError: false
};



// WEBPACK FOOTER //
// ./src/reducers/defaultStates.js